import { render, staticRenderFns } from "./ButtonRegisterQuery.vue?vue&type=template&id=4578f34e&scoped=true&"
import script from "./ButtonRegisterQuery.vue?vue&type=script&lang=js&"
export * from "./ButtonRegisterQuery.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRegisterQuery.vue?vue&type=style&index=0&id=4578f34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578f34e",
  null
  
)

export default component.exports